export function formatCurrency(number: number): string {
  return Intl.NumberFormat('pt-br', {
    currency: 'BRL',
    style: 'currency',
  }).format(number);
}
